import { format, isDate, isToday, isYesterday } from 'date-fns';
import numeral from 'numeral';
import pluralize from 'pluralize';

import { IFont } from './types';

export function displayTerm(term: number) {
  return `${term} ${pluralize('month', term)}`;
}

export function displayGuests(guests: number) {
  return `${guests} ${pluralize('guests', guests)}`;
}

export function displayFonts(fonts: IFont[]) {
  return `${pluralize('Fonts', fonts.length)} ${fonts}`;
}

const toDate = (date: any) => (isDate(date) ? date : new Date(date));

export const formatDateTime = (value: any) => {
  const date = toDate(value);

  return format(date, 'h:mm a');
};

export const formatChatDate = (value: any) => {
  const date = toDate(value);

  if (isToday(date)) {
    return 'Today';
  }

  if (isYesterday(date)) {
    return 'Yesterday';
  }

  return format(date, 'E, M/dd/yy');
};

export function currencyFormat(value?: number) {
  return numeral(value).format('0,0[.]00');
}
